import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import ActionsModal from 'components/ActionsModal'

import {
  selectDisplayedOrganization,
  updateDisplayedOrganization,
  closeDisplayedOrganization,
} from 'store/organizations'

import { selectOrganizations } from 'store/global'
import messages from './messages'

export default function CreateOrganizationModal({ onSubmit }) {
  const dispatch = useDispatch()

  const allOrganizations = useSelector(selectOrganizations)
  const displayedOrganization = useSelector(selectDisplayedOrganization)

  const onFieldChange = (key, value) => dispatch(updateDisplayedOrganization({ key, value }))

  const onCloseModal = () => dispatch(closeDisplayedOrganization())

  const isOrganizationNameAvailable = name => allOrganizations.every(organization => organization.name !== name)

  const isOrganizationAliasAvailable = alias => allOrganizations.every(organization => organization.alias !== alias)

  const isOrganizationDomainsAvailable = domains => allOrganizations.every(organization => organization.domains !== domains)

  const fields = {
    name: {
      key: 'name',
      isRequired: true,
      label: <FormattedMessage {...messages.labels.name} />,
      validator: isOrganizationNameAvailable,
      formFeedback: <FormattedMessage {...messages.formFeedback.nameUnavailable} />,
    },
    alias: {
      key: 'alias',
      isRequired: true,
      validator: isOrganizationAliasAvailable,
      label: <FormattedMessage {...messages.labels.alias} />,
    },
    domains: {
      key: 'domains',
      isRequired: true,
      validator: isOrganizationDomainsAvailable,
      label: <FormattedMessage {...messages.labels.domains} />,
    },
  }

  const handleSubmit = () => {
    onSubmit(displayedOrganization )
  }

  return (
    <ActionsModal
      type='organization'
      mode='create'
      item={displayedOrganization}
      primaryKey='name'
      fields={fields}
      onFieldChange={onFieldChange}
      onClose={onCloseModal}
      onSubmit={handleSubmit}
    />
  )
}

CreateOrganizationModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
} 